import { Link } from "react-router-dom";
import PaymentMethodsFooter from "./PaymentMethodsFooter";
const openExternal = (url: string) => {
  // Try opening in new tab
  const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
  if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
    // If popup was blocked, try navigating in top window
    try {
      window.top?.open(url, '_blank');
    } catch {
      // Last fallback: copy to clipboard and alert user
      navigator.clipboard.writeText(url).then(() => {
        alert(`Link copiado! Cole no seu navegador: ${url}`);
      }).catch(() => {
        alert(`Por favor, acesse: ${url}`);
      });
    }
  }
};
const Footer = ({ hidePaymentMethods = false }: { hidePaymentMethods?: boolean }) => {
  return <footer className="bg-[#f5f5f7]">
      {/* Seção Promocional */}
      
      
      <div className="container mx-auto px-4 max-w-7xl pt-8 pb-6">
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-8 mb-6">
          <div>
            {/* Link com âncora acessível: o alt da imagem descreve o destino. */}
            <Link to="/" className="flex items-center mb-4" aria-label="AmeUp — página inicial">
              <img src="https://qfozcnxbtjjmidhjdepc.supabase.co/storage/v1/object/public/favicon/favicon-192x192.png" alt="AmeUp Logo" className="h-10 w-auto mr-2 object-contain" loading="lazy" />
            </Link>

            <p className="text-muted-foreground mb-4">
              Digitalize, Cresça e Multiplique
            </p>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">AmeUp</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/sobre-nos" className="text-gray-500 hover:text-primary transition">Sobre Nós</Link>
              </li>
              <li>
                <Link to="/problema-solucao" className="text-gray-500 hover:text-primary transition">Problema vs Solução</Link>
              </li>
              <li>
                <Link to="/materiais-gratuitos" className="text-gray-500 hover:text-primary transition">Materiais Gratuitos</Link>
              </li>

              <li>
                <Link to="/blog" className="text-gray-500 hover:text-primary transition">Blog</Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">Fornecedores</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/cadastro-fornecedor" className="text-gray-500 hover:text-primary transition">Quero testar</Link>
              </li>
              <li>
                <Link to="/materiais-gratuitos" className="text-gray-500 hover:text-primary transition">Materiais gratuitos</Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">Fale com a Ame</h3>
            <ul className="space-y-3">
              <li className="flex items-start">
                <svg className="h-6 w-6 text-primary mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <span className="text-gray-500">dev@ameup.com.br</span>
              </li>
              <li className="flex items-start">
                <svg className="h-6 w-6 text-primary mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
                </svg>
                <span className="text-gray-500">(11) 91493-5333</span>
              </li>
              <li className="flex items-start">
                <a href="https://www.instagram.com/ameupbr" className="text-[#fb583a] hover:text-primary transition flex items-start cursor-pointer" target="_blank" rel="noopener noreferrer" onClick={e => {
                e.preventDefault();
                openExternal('https://www.instagram.com/ameupbr');
              }} aria-label="Visite nosso Instagram @ameupbr" title="Instagram da AmeUp">
                  <svg className="h-6 w-6 mr-2 flex-shrink-0" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path fillRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clipRule="evenodd" />
                  </svg>
                  <span className="text-zinc-500">@ameupbr</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        {/* Nova seção de Termos e Política */}
        <div className="border-t border-gray-200 pt-6 mb-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            <div>
              <h3 className="text-lg font-semibold mb-2">Legal</h3>
              <div className="flex flex-col sm:flex-row gap-4">
                <Link to="/termos-de-uso" className="text-gray-500 hover:text-primary transition underline">
                  Termos de Uso
                </Link>
                <Link to="/politica-de-privacidade" className="text-gray-500 hover:text-primary transition underline">
                  Política de Privacidade
                </Link>
              </div>
            </div>
            
            {/* Payment Methods Section */}
            {!hidePaymentMethods && (
              <div className="flex justify-center">
                <PaymentMethodsFooter />
              </div>
            )}
            
            {/* Selos / Programas */}
            <div className="flex flex-col items-center">
              <p className="text-sm text-gray-600 mb-3 font-medium">Aceleradoras</p>
              <div className="flex items-center justify-center gap-6 flex-wrap">
                <img src="https://qfozcnxbtjjmidhjdepc.supabase.co/storage/v1/object/public/image-introdution/thumbnail_Selo%20Startup%20Caldeira.png" alt="Selo Startup Caldeira" className="h-16 w-auto mix-blend-multiply" />
                <img src="https://qfozcnxbtjjmidhjdepc.supabase.co/storage/v1/object/public/Photos_Home/RME.png" alt="RME" className="h-16 w-auto mix-blend-multiply" />
                <img src="https://qfozcnxbtjjmidhjdepc.supabase.co/storage/v1/object/public/Photos_Home/Female%20Force.png" alt="Female Force" className="h-16 w-auto mix-blend-multiply" />
              </div>
            </div>

          </div>
        </div>
        
        <div className="border-t border-gray-200 pt-4 text-center text-sm text-gray-500">
          <p>AMEUP COMÉRCIO LTDA - CNPJ: 59.792.355/0001-03</p>
          <p className="mt-2">&copy; {new Date().getFullYear()} AmeUp. Todos os direitos reservados.</p>
          <p className="mt-2 text-primary font-medium">Digitalize, Cresça e Multiplique</p>
        </div>
      </div>
    </footer>;
};
export default Footer;